import { generateMedia } from 'styled-media-query';

import { breakpoints } from '../theme/breakpoints';

interface BreakpointsProps {
  xs: string;
  s: string;
  m: string;
  l: string;
  xl: string;
  xxl: string;
}

export const media = generateMedia<BreakpointsProps, any>(breakpoints);
